import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';

export default function DepartmentsList() {
  const navigate = useNavigate();
  const [departments, setDepartments] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadDepartments = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await axios.get('/departments');
        setDepartments(response.data);
      } catch (err) {
        const message = err.response?.data?.message || 'No se pudieron cargar los departamentos.';
        setError(message);
      } finally {
        setIsLoading(false);
      }
    };

    loadDepartments();
  }, []);

  const handleDelete = async (departmentId) => {
    const confirmDelete = window.confirm('Seguro que deseas eliminar este departamento?');
    if (!confirmDelete) {
      return;
    }
    setDeleteId(departmentId);
    setError(null);
    try {
      await axios.delete(`/departments/${departmentId}`);
      setDepartments((prev) => prev.filter((department) => department.id !== departmentId));
    } catch (err) {
      const message = err.response?.data?.message || 'No se pudo eliminar el departamento.';
      setError(message);
    } finally {
      setDeleteId(null);
    }
  };

  return (
    <div className="container mx-auto p-6">
      <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-3xl font-bold text-gray-800">Departamentos</h1>
          <p className="text-sm text-gray-500">Organiza las areas y equipos.</p>
        </div>
        <button
          onClick={() => navigate('/home/departamentos/nuevo')}
          className="rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700"
        >
          Nuevo departamento
        </button>
      </div>

      {error && <div className="mb-4 rounded-lg bg-red-50 px-4 py-2 text-sm text-red-600">{error}</div>}

      <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
        {isLoading ? (
          <div className="p-6 text-sm text-gray-500">Cargando departamentos...</div>
        ) : departments.length === 0 ? (
          <div className="p-6 text-sm text-gray-500">No hay departamentos registrados.</div>
        ) : (
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">
                  Codigo
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">
                  Nombre
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">
                  Estado
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">
                  Descripcion
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {departments.map((department) => (
                <tr key={department.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm font-medium text-gray-900">{department.code}</td>
                  <td className="px-6 py-4 text-sm text-gray-500">{department.name}</td>
                  <td className="px-6 py-4 text-sm text-gray-500">{department.status}</td>
                  <td className="px-6 py-4 text-sm text-gray-500">
                    {department.description || '--'}
                  </td>
                  <td className="px-6 py-4 text-sm">
                    <div className="flex flex-wrap gap-2">
                      <button
                        onClick={() => navigate(`/home/departamentos/editar/${department.id}`)}
                        className="rounded bg-gray-100 px-3 py-1 text-xs font-semibold text-gray-700 hover:bg-gray-200"
                      >
                        Editar
                      </button>
                      <button
                        onClick={() => handleDelete(department.id)}
                        disabled={deleteId === department.id}
                        className="rounded bg-red-600 px-3 py-1 text-xs font-semibold text-white hover:bg-red-700 disabled:opacity-60"
                      >
                        {deleteId === department.id ? 'Eliminando...' : 'Eliminar'}
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
